"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OcppIdTokenAuthorizationSerialization = void 0;
class OcppIdTokenAuthorizationSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.payment_presented_timestamp = entity.payment_presented_timestamp
            ? entity.payment_presented_timestamp.getTime() * 1000000
            : undefined;
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.payment_presented_timestamp = entity.payment_presented_timestamp
            ? new Date(entity.payment_presented_timestamp / 1000000)
            : undefined;
        return copy;
    }
}
exports.OcppIdTokenAuthorizationSerialization = OcppIdTokenAuthorizationSerialization;
